import { memo, ReactElement } from 'react'

import isEqual from 'lodash/isEqual'

import { deleteLabel } from 'api/Cerebro/orgScoped/labelsApi'
import { fetchOrganizationLabels } from 'features/App/appService'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions } from 'hooks'
import { Label } from 'types'

import { DeleteField } from '../SharedFields/DeleteField'

interface Props<RecordType> {
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function DeleteLabelField<RecordType extends Label>({
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const hasPermission = useUserHasPermissions(userHasManageLabelsPermissions)

    return (
        <DeleteField
            disabled={!hasPermission || readOnly}
            okText="Delete"
            title="Are you sure you want to delete this Label?"
            updateRequestApi={deleteLabel}
            updateRequestCallback={() => {
                // reload table
                reloadData()
                // refresh app-level labels
                fetchOrganizationLabels().catch(() => {})
            }}
            updateRequestData={record.id}
            updateRequestSuccessMesg="Label successfully deleted"
        />
    )
}

export default memo(DeleteLabelField, isEqual) as typeof DeleteLabelField
